import { InjectionToken } from '@angular/core';

export class AuthenticationGuardConfig {
  loginPath?: string;
  unauthorizedPath?: string;
}

export const AuthenticationGuardConfigService = new InjectionToken<AuthenticationGuardConfig>('AuthenticationGuardConfig');
